import Relay from 'react-relay';

class CreateEventMutation extends Relay.Mutation {
  getMutation = () => Relay.QL`mutation {createEvent}`;

  getVariables() {
    return {
      startDate: {
        date: this.props.eventData.startDate.unix(),
        timezone: this.props.eventData.timezone,
      },
      endDate: {
        date: this.props.eventData.endDate.unix(),
        timezone: this.props.eventData.timezone,
      },
      subject: this.props.eventData.title,
      body: this.props.eventData.body,
      organizer: this.props.eventData.chair.email,
      requiredAttendees: this.props.eventData.required.map(
        c => ({
          email: c.email || c.value,
        })
      ),
    };
  }
  getFatQuery() {
    return Relay.QL`
      fragment on CreateEventPayload {
        clientMutationId
        event {
          id
          iCalUId
          subject
          startDate
          endDate
          location {
            displayName
          }
          organizer {
            displayName
            email
          }
          requiredAttendees {
            displayName
            email
          }
          optionalAttendees {
            displayName
            email
          }
        }
      }
    `;
  }
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [Relay.QL`
        fragment on CreateEventPayload {
          clientMutationId
          event {
            id
            iCalUId
            subject
            startDate
            endDate
            location {
              displayName
            }
            organizer {
              displayName
              email
            }
            requiredAttendees {
              displayName
              email
            }
            optionalAttendees {
              displayName
              email
            }
          }
        }
      `],
    }];
  }
}

export default CreateEventMutation;



// WEBPACK FOOTER //
// ./src/js/Mutations/CreateEventMutation.js